import { formatValueByType } from "./utils/formatValueByType";

const mapCard = (json) => {
    const { ColumnsByLocale, FieldsData } = json;
    const parsedColumnsByLocale = JSON.parse(ColumnsByLocale || "{}");
    const parsedFieldData = JSON.parse(FieldsData || "{}");
    const resultCard = Object.keys(parsedColumnsByLocale).map((elem) => {
        const { type, basis, options, mask, align } = parsedColumnsByLocale[elem];
        return [
            {
                labels: [elem],
                ...formatValueByType(parsedFieldData, parsedFieldData[elem], type, options, mask),
                align: align ? align : "left",
                basis,
            },
        ];
    });
    resultCard.unshift([
        {
            labels: ["F60"],
            type: "string",
            align: "left",
            value: parsedFieldData["F60"],
        },
    ]);
    return resultCard;
};

const mapper = (json, card) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
    };
};

const header = (json) => {
    const headerMapping = Object.keys(json).map((elem) => {
        if (json[elem]) {
            const { name: label, align, basis, minWidth = 150 } = json[elem];
            return {
                label: [elem],
                align: align ? align : "left",
                minWidth: minWidth,
                headerName: label,
                basis,
            };
        } else {
            return undefined;
        }
    });
    headerMapping.unshift({
        label: ["Group"],
        align: "left",
        minWidth: 150,
    });
    return headerMapping;
};

const factCustomtMapper = {
    map: mapper,
    header,
};

export default factCustomtMapper;
